import _ from 'lodash'

// Terrible jokes courtesy of Toontown
// https://toontown.fandom.com/wiki/Knock-knock_jokes
const jokes = [
    ['Wally', 'Wally who?', "Wally's not looking, hit him with a pie!"],
    ['Minnie', 'Minnie who?', "Minnie people have asked me that and it's driving me crazy!"],
    ['Aladdin', 'Aladdin who?', 'Aladdin HQ wants a word with you.'],
    ['Isaiah', 'Isaiah who?', 'Isaiah we go ride the trolley.'],
    ['Who', 'Who who?', "Bad echo in here, isn't there?"],
    ['Dozen', 'Dozen who?', 'Dozen anybody want to let me in?'],
    ['Freddie', 'Freddie who?', 'Freddie or not, here I come.'],
    ['Dishes', 'Dishes who?', 'Dishes your friend, let me in.'],
    ['Wooden shoe', 'Wooden shoe who?', 'Wooden shoe like to know?'],
    ['Betty', 'Betty who?', "Betty doesn't know who I am."],
    ['Kent', 'Kent who?', 'Kent you tell?'],
    ['Noah', 'Noah who?', "Noah don't know either."],
    ["I don't know", "I don't know who?", 'Nether do I, I keep telling you that.'],
    ['Howard', 'Howard who?', 'Howard I know?'],
    ['Emma', 'Emma who?', 'Emma so glad you asked me that.'],
    ['Auto', 'Auto who?', "Auto know, but I've forgotten."],
    ['Jess', 'Jess who?', 'Jess me and my shadow.'],
    ['One', 'One who?', 'One-der why you keep asking that?'],
    ['Alma', 'Alma who?', 'Alma not going to tell you!'],
    ['Zoom', 'Zoom who?', 'Zoom do you expect?'],
    ['Amy', 'Amy who?', "Amy fraid I've forgotten."],
    ['Arfur', 'Arfur who?', 'Arfur got.'],
    ['Ewan', 'Ewan who?', 'No, just me.'],
    ['Cozy', 'Cozy who?', "Cozy who's knocking, will you?"],
    ['Sam', 'Sam who?', 'Sam person who knocked on the door last time.'],
    ['Fozzie', 'Fozzie who?', 'Fozzie hundredth time, my name is Flippy.'],
    ['Deduct', 'Deduct who?', 'Donald Deduct.'],
    ['Max', 'Max who?', 'Max no difference, just open the door.'],
    ['N. E', 'N.E. who?', 'N.E. body you like, let me in.'],
    ['Amos', 'Amos who?', 'Amos-quito bit me.'],
    ['Alma', 'Alma who?', "Alma candy's gone!"],
    ['Bruce', 'Bruce who?', "I Bruce very easily, so don't hit me."],
    ['Colleen', 'Colleen who?', "Colleen your room, it's filthy."],
    ['Elsie', 'Elsie who?', 'Elise you later.'],
    ['Hugh', 'Hugh who?', 'Hugh is going to let me in?'],
    ['Hugo', 'Hugo who?', "Hugo first - I'm scared."],
    ['Ida', 'Ida who?', 'Ida know. Sorry!'],
    ['Isabel', 'Isabel who?', 'Isabel on a bike really necessary?'],
    ['Joan', 'Joan who?', "Joan call us, we'll call you."],
    ['Kay', 'Kay who?', 'Kay, L, M, N, O, P.'],
    ['Justin', 'Justin who?', 'Justin time for dinner.'],
    ['Liza', 'Liza who?', 'Liza wrong to tell.'],
    ['Luke', 'Luke who?', 'Luke and see who it is.'],
    ['Mandy', 'Mandy who?', "Mandy the lifeboats, we're sinking."],
    ['Max', 'Max who?', 'Max on difference, just open the door!'],
    ['Nettie', 'Nettie who?', 'Nettie as a fruitcake.'],
    ['Olivia', 'Olivia who?', 'Olivia me alone!'],
    ['Oscar', 'Oscar who?', 'Oscar a stupid question, you get a stupid answer.'],
    ['Patsy', 'Patsy who?', 'Patsy dog on the head, he likes it.'],
    ['Paul', 'Paul who?', "Paul hard, the door's stuck again."],
    ['Thea', 'Thea who?', 'Thea later, alligator.'],
    ['Tyrone', 'Tyrone who?', 'Tyrone your shoelaces, your old enough.'],
    ['Stella', 'Stella who?', 'Stella no answer at the door.'],
    ['Uriah', 'Uriah who?', 'Keep Uriah on the ball.'],
    ['Dwayne', 'Dwayne who?', "Dwayne the bathtub. I'm drowning."],
    ['Dismay', 'Dismay who?', "Dismay be a joke, but it didn't make me laugh."],
    ['Ocelot', 'Ocelot who?', "Ocelot of questions, don't you?"],
    ['Thermos', 'Thermos who?', 'Thermos be a better knock knock joke than this.'],
    ['Sultan', 'Sultan who?', 'Sultan Pepper.'],
    ['Vaughen', 'Vaughen who?', 'Vaughen my prince will come.'],
    ['Donald', 'Donald who?', 'Donald come baby, cradle and all.'],
    ['Lettuce', 'Lettuce who?', "Lettuce in, won't you?"],
    ['Ivor', 'Ivor who?', 'Ivor sore hand from knocking on your door!'],
    ['Isabel', 'Isabel who?', 'Isabel broken because I had to knock.'],
    ['Haywood, Hugh, Harry', 'Haywood, Hugh, Harry who?', 'Haywood, Hugh, Harry up and open this door.'],
    ['Juan', 'Juan who?', "Juan of these days you'll find out."],
    ['Earl', 'Earl who?', 'Earl be glad to tell you if you open this door.'],
    ['Abbot', 'Abbot who?', 'Abbot time you let me in!'],
    ['Ferdie', 'Ferdie who?', 'Ferdie last time, open this door!'],
    ['Don', 'Don who?', 'Don mess around, and just open the door.'],
    ['Sis', 'Sis who?', 'Sis anyway to treat a friend?'],
    ['Isadore', 'Isadore who?', 'Isadore open or locked?'],
    ['Harry', 'Harry who?', 'Harry up and let me in!'],
    ['Theodore', 'Theodore who?', "Theodore wasn't open so I knock-knocked."],
    ['Ken', 'Ken who?', 'Ken I come in?'],
    ['Boo', 'Boo who?', "There's no need to cry about it."],
    ['You', 'You who?', 'You who! Is there anybody there?'],
    ['Ice cream', 'Ice cream who?', "Ice cream if you don't let me in."],
    ['Sarah', 'Sarah who?', "Sarah 'nother way into this building?"],
    ['Mikey', 'Mikey who?', 'Mikey dropped down the drain.'],
    ['Doris', 'Doris who?', 'Doris jammed again.'],
    ['Yelp', 'Yelp who?', 'Yelp me, the door is stuck.'],
    ['Scold', 'Scold who?', 'Scold outside.'],
    ['Diana', 'Diana who?', 'Diana third, can I have a drink please?'],
    ['Doris', 'Doris who?', 'Doris slammed on my finger, open it quick!'],
    ['Lettuce', 'Lettuce who?', 'Lettuce tell you some knock knock jokes.'],
    ['Izzy', 'Izzy who?', 'Izzy come, izzy go.'],
    ['Omar', 'Omar who?', 'Omar goodness gracious - wrong door!'],
    ['Says', 'Says who?', "Says me, that's who!"],
    ['Duck', 'Duck who?', "Just duck, they're throwing things at us."],
    ['Tank', 'Tank who?', "You're welcome."],
    ['Eyes', 'Eyes who?', 'Eyes got loads more knock knock jokes for you.'],
    ['Pizza', 'Pizza who?', 'Pizza cake would be great right now.'],
    ['Closure', 'Closure who?', 'Closure mouth when you eat.'],
    ['Harriet', 'Harriet who?', "Harriet all my lunch, I'm starving."],
    ['Wooden', 'Wooden who?', 'Wooden you like to know?'],
    ['Punch', 'Punch who?', 'Not me, please.'],
    ['Gorilla', 'Gorilla who?', 'Gorilla me a hamburger.'],
    ['Jupiter', 'Jupiter who?', "Jupiter hurry, or you'll miss the trolley."],
    ['Bertha', 'Bertha who?', 'Happy Bertha to you!'],
    ['Cows', 'Cows who?', 'Cows go "moo" not "who."'],
    ['Tuna fish', 'Tuna fish who?', "You can tune a piano, but you can't tuna fish."],
    ['Consumption', 'Consumption who?', 'Consumption be done about all these knock knock jokes?'],
    ['Banana', 'Banana who?', 'Banana split so ice creamed.'],
    ['X', 'X who?', 'X-tremely pleased to meet you.'],
    ['Haydn', 'Haydn who?', 'Haydn seek is fun to play.'],
    ['Rhoda', 'Rhoda who?', 'Rhoda boat as fast as you can.'],
    ['Quacker', 'Quacker who?', "Quacker 'nother bad joke and I'm off!"],
    ['Nana', 'Nana who?', 'Nana your business.'],
    ['Ether', 'Ether who?', 'Ether bunny.'],
    ['Little old lady', 'Little old lady who?', "My, you're good at yodeling!"],
    ['Beets', 'Beets who?', 'Beets me, I forgot the joke.'],
    ['Hal', 'Hal who?', 'Halloo to you too!'],
    ['Sarah', 'Sarah who?', 'Sarah doctor in the house?'],
    ['Aileen', 'Aileen who?', 'Aileen Dover and fell down.'],
    ['Atomic', 'Atomic who?', 'Atomic ache.'],
    ['Agatha', 'Agatha who?', 'Agatha headache. Got an aspirin?'],
    ['Stan', 'Stan who?', "Stan back, I'm going to sneeze."],
    ['Hatch', 'Hatch who?', 'Bless you.'],
    ['Ida', 'Ida who?', "It's not Ida who, it's Idaho."],
    ['Zippy', 'Zippy who?', 'Mrs. Zippy.'],
    ['Yukon', 'Yukon who?', 'Yukon go away and come back another time.'],
]

export default async ({ output }) => {
    await output('Knock-knock')
    await output("Who's there?")
    const joke = _.sample(jokes)
    await output(joke[0])
    await output(joke[1])
    await output(joke[2])
}
